import { FC } from "react";
import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerBody,
  DrawerCloseButton,
  DrawerFooter,
  Button,
} from "@chakra-ui/react";
// import { CardElement } from "@stripe/react-stripe-js";

interface PaymentDisclosureProps {
  paymentDisclosure: any;
  loading: boolean;
  handlePayPress: any;
  CardElement: any;
}

export const PaymentDisclosure: FC<PaymentDisclosureProps> = ({
  paymentDisclosure,
  loading,
  handlePayPress,
  CardElement,
}) => {
  return (
    <Drawer
      placement={"bottom"}
      onClose={paymentDisclosure.onClose}
      isOpen={paymentDisclosure.isOpen}
    >
      <DrawerOverlay />

      <DrawerContent borderTopLeftRadius={"20px"} borderTopRightRadius={"20px"}>
        <DrawerCloseButton />

        <DrawerBody py="50px">
          <CardElement
            options={{
              hidePostalCode: true,
              style: {
                base: {
                  // backgroundColor: "red",
                  padding: "12px",
                },
              },
            }}
          />
          {/* <PaymentElement /> */}
        </DrawerBody>

        <DrawerFooter boxShadow="0px 5px 10px rgba(0, 0, 0, 0.4)">
          <Button
            bg={"#FF8E3C"}
            _hover={{ bg: "#FF8E3C" }}
            borderRadius={"30px"}
            color={"white"}
            w="100%"
            h="58px"
            fontSize={"17px"}
            fontFamily={"RedHatDisplay-Bold"}
            onClick={handlePayPress}
            isLoading={loading}
            disabled={loading}
          >
            Continue
          </Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};
